import { hooks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackSiteLoaded = () => {
  hooks.operations.subscribe(hooks.availableHooks.ON_SITE_LOADED, () => {
    trackEvent(constants.events.SITE_LOADED);
  });
};

export default trackSiteLoaded;
